import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IWorkspaceTrustEnablementService, IWorkspaceTrustManagementService } from 'vscode/vscode/vs/platform/workspace/common/workspaceTrust.service';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { IWorkbenchExtensionEnablementService } from 'vscode/vscode/vs/workbench/services/extensionManagement/common/extensionManagement.service';
import { IExtensionService } from 'vscode/vscode/vs/workbench/services/extensions/common/extensions.service';
import { IHostService } from 'vscode/vscode/vs/workbench/services/host/browser/host.service';

const _moduleId = "vs/workbench/contrib/extensions/browser/extensionEnablementWorkspaceTrustTransitionParticipant";
let ExtensionEnablementWorkspaceTrustTransitionParticipant = class ExtensionEnablementWorkspaceTrustTransitionParticipant extends Disposable {
    constructor(extensionService, hostService, environmentService, extensionEnablementService, workspaceTrustEnablementService, workspaceTrustManagementService) {
        super();
        if (workspaceTrustEnablementService.isWorkspaceTrustEnabled()) {
            workspaceTrustManagementService.workspaceTrustInitialized.then(() => {
                const workspaceTrustTransitionParticipant = new (class {
                    async participate(trusted) {
                        if (trusted) {
                            await extensionEnablementService.updateExtensionsEnablementsWhenWorkspaceTrustChanges();
                        }
                        else {
                            if (environmentService.remoteAuthority) {
                                hostService.reload();
                            }
                            else {
                                const stopped = await extensionService.stopExtensionHosts(( localizeWithPath(_moduleId, 0, "Restarting extension host due to workspace trust change.")));
                                await extensionEnablementService.updateExtensionsEnablementsWhenWorkspaceTrustChanges();
                                if (stopped) {
                                    extensionService.startExtensionHosts();
                                }
                            }
                        }
                    }
                });
                this._register(workspaceTrustManagementService.addWorkspaceTrustTransitionParticipant(workspaceTrustTransitionParticipant));
            });
        }
    }
};
ExtensionEnablementWorkspaceTrustTransitionParticipant = ( (__decorate([
    ( (__param(0, IExtensionService))),
    ( (__param(1, IHostService))),
    ( (__param(2, IWorkbenchEnvironmentService))),
    ( (__param(3, IWorkbenchExtensionEnablementService))),
    ( (__param(4, IWorkspaceTrustEnablementService))),
    ( (__param(5, IWorkspaceTrustManagementService)))
], ExtensionEnablementWorkspaceTrustTransitionParticipant)));

export { ExtensionEnablementWorkspaceTrustTransitionParticipant };
